// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpTc3S8_u4 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.SpTc3S8_u4 h4 {
  line-height: 3em;
}
.SpTc3S8_u4 .z76Yd5ir6W {
  float: left;
  width: 100%;
}
.SpTc3S8_u4 .AvBG_jGtsk {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.SpTc3S8_u4 .AvBG_jGtsk:hover {
  cursor: pointer;
}
.SpTc3S8_u4 .AvBG_jGtsk:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.mRmb2gSajN .klEGwREbnk:focus {
  outline: none;
}
.mRmb2gSajN .klEGwREbnk.CGVCCZxHOo.s19Cbq3fbD {
  background: #375A88;
}
.mRmb2gSajN .klEGwREbnk.CGVCCZxHOo.s19Cbq3fbD span {
  color: #fff;
}
.mRmb2gSajN .s19Cbq3fbD {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.mRmb2gSajN .s19Cbq3fbD:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.mRmb2gSajN input {
  height: 38px;
  min-width: 220px;
}
.AvBG_jGtsk.YilDKf9sK7 {
  background: #410102;
}
.AvBG_jGtsk.I_dorVJ0YR {
  background: #911318;
}
.AvBG_jGtsk.cjPV5G9cgB {
  background: #D8293B;
}
.AvBG_jGtsk.V5SQcj3NWh {
  background: #F2373C;
}
.AvBG_jGtsk.KmeeCTX04q {
  background: #FC4448;
}
.AvBG_jGtsk.Ezb0iyeWdA {
  background: #ED535E;
}
.AvBG_jGtsk.P9WgOoRg0B {
  background: #E34926;
}
.AvBG_jGtsk.MdqPZDmOeT {
  background: #FC562B;
}
.AvBG_jGtsk.tBIvE7rcCn {
  background: #FC6722;
}
.AvBG_jGtsk.otGDJYF91m {
  background: #FD7F24;
}
.AvBG_jGtsk.toUiHmq7d9 {
  background: #FD8D26;
}
.AvBG_jGtsk.AJMf59lxm7 {
  background: #EC9C3E;
}
.AvBG_jGtsk.Ydcgqnfe2R {
  background: #0e673a;
}
.AvBG_jGtsk.I2UlnPBBW2 {
  background: #208740;
}
.AvBG_jGtsk.QIbcc2nbqy {
  background: #239718;
}
.AvBG_jGtsk.vscT7Q2u8Z {
  background: #55A84D;
}
.AvBG_jGtsk.dpnnthCuIw {
  background: #4BBE5A;
}
.AvBG_jGtsk.fwS3gtYhKO {
  background: #0CCA6A;
}
.AvBG_jGtsk.clODwYArC8 {
  background: #0A3C64;
}
.AvBG_jGtsk.kHLwI410S6 {
  background: #0d487a;
}
.AvBG_jGtsk.fJq4a8AqU1 {
  background: #10538d;
}
.AvBG_jGtsk.Sa0OGdMTdo {
  background: #115A99;
}
.AvBG_jGtsk.nHyqbGCBUt {
  background: #3387E2;
}
.AvBG_jGtsk.gRKqnSXsQF {
  background: #1BA9CF;
}
.AvBG_jGtsk.wyqTeK8lPS {
  background: #d27c02;
}
.AvBG_jGtsk.JeiSKWVSP7 {
  background: #fb9402;
}
.AvBG_jGtsk.giTMbJJHR5 {
  background: #FD9B30;
}
.AvBG_jGtsk.VwYbtvOrxL {
  background: #FDBE2D;
}
.AvBG_jGtsk.UNi9wcwjlI {
  background: #FED831;
}
.AvBG_jGtsk.YhTSRK29yH {
  background: #FFFD38;
}
.AvBG_jGtsk.GRs1gtIfSD {
  background: #2D215C;
}
.AvBG_jGtsk.QLDX8bwiGE {
  background: #483C83;
}
.AvBG_jGtsk.LAmyUFDR73 {
  background: #58518d;
}
.AvBG_jGtsk.MAjXCH77Sx {
  background: #7068A9;
}
.AvBG_jGtsk.wMqIn2AIoz {
  background: #7f78b2;
}
.AvBG_jGtsk.Ed9JzYZuUh {
  background: #8f88bc;
}
.AvBG_jGtsk.MWw_wT5ILH {
  background: #000;
}
.AvBG_jGtsk.bP0BWW9J46 {
  background: #282626;
}
.AvBG_jGtsk.kdwoKnF68c {
  background: #242222;
}
.AvBG_jGtsk.RujWf9GyZs {
  background: #353838;
}
.AvBG_jGtsk.fZ1_KBBR3q {
  background: #666;
}
.AvBG_jGtsk.G6XQtzRy4l {
  background: #999;
}
.N1riCr_vo2 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.N1riCr_vo2 .gX1cZ64IMN {
  display: none;
}
.k20FCthscX {
  min-width: 900px;
  height: 576px;
}
.k20FCthscX .T39xG6gev6 {
  position: relative;
  max-height: 66px;
  background-color: #375A87;
}
.k20FCthscX .T39xG6gev6 .aIc97jJ7zA {
  display: flex;
  align-items: baseline;
}
.k20FCthscX .T39xG6gev6 .aIc97jJ7zA .e7QZc6WuSA.e7QZc6WuSA {
  font-size: 20px;
}
.k20FCthscX .T39xG6gev6 .aIc97jJ7zA .PQM8AvKK5w {
  font-size: 28px;
}
.k20FCthscX .lsnuHkEbaK {
  max-height: 60px;
  align-items: center;
}
.k20FCthscX .lsnuHkEbaK .qblwVBZX9h.qblwVBZX9h {
  background-color: #e5e5e5;
  color: #000000;
}
.k20FCthscX .lsnuHkEbaK .UPgS7D1Rbm.UPgS7D1Rbm {
  background-color: #e5e5e5;
  color: #000000;
}
.k20FCthscX .O8HkpW5rNm {
  padding: 20px;
}
.k20FCthscX .O8HkpW5rNm .Sb8t5VELh8 {
  display: grid;
  align-items: end;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}
.k20FCthscX .O8HkpW5rNm .Sb8t5VELh8 .hjQtq9XPz3 {
  background-color: #fff;
}
.k20FCthscX .O8HkpW5rNm .Sb8t5VELh8 .SYrrQEYWCE {
  border: solid 1px #e5e5e5;
  background-color: #f5f5f5;
  height: 32px;
}
.k20FCthscX .O8HkpW5rNm .Sb8t5VELh8 .SYrrQEYWCE .sBpJOsQWHy {
  border: none;
  font-size: 12px !important;
  padding: 0;
}
.k20FCthscX .O8HkpW5rNm .Sb8t5VELh8 .SYrrQEYWCE .s_BB3Paszk {
  font-size: 16px;
  padding: 4px 12px;
}
.k20FCthscX .O8HkpW5rNm .b-grid-header .b-checkbox input[type='checkbox']:checked + .b-checkbox-label::before,
.k20FCthscX .O8HkpW5rNm .b-grid-cell .b-checkbox input[type='checkbox']:checked + .b-checkbox-label::before {
  background-color: #00739a;
  border-radius: 3px;
  color: #fff;
}
.k20FCthscX .O8HkpW5rNm .b-check-cell {
  padding: 0;
}
.k20FCthscX .O8HkpW5rNm .b-label.b-align-start {
  color: #616161 !important;
}
.k20FCthscX .O8HkpW5rNm .b-field-inner.b-field-inner {
  border-color: #d0d1d2 !important;
}
.k20FCthscX .O8HkpW5rNm .b-field-inner.b-field-inner:disabled {
  border-color: #d0d1d2 !important;
}
.k20FCthscX .O8HkpW5rNm .b-label.b-align-start {
  color: #616161 !important;
}
.k20FCthscX .O8HkpW5rNm .b-field-inner.b-field-inner {
  border-color: #d0d1d2 !important;
}
.k20FCthscX .O8HkpW5rNm .b-field-inner.b-field-inner:disabled {
  border-color: #d0d1d2 !important;
}
.k20FCthscX .O8HkpW5rNm .b-virtual-scrollers {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `SpTc3S8_u4`,
	"color-row": `z76Yd5ir6W`,
	"color-tile": `AvBG_jGtsk`,
	"picker-component": `mRmb2gSajN`,
	"picker-element": `klEGwREbnk`,
	"active": `CGVCCZxHOo`,
	"btn": `s19Cbq3fbD`,
	"red-1": `YilDKf9sK7`,
	"red-2": `I_dorVJ0YR`,
	"red-3": `cjPV5G9cgB`,
	"red-4": `V5SQcj3NWh`,
	"red-5": `KmeeCTX04q`,
	"red-6": `Ezb0iyeWdA`,
	"orange-1": `P9WgOoRg0B`,
	"orange-2": `MdqPZDmOeT`,
	"orange-3": `tBIvE7rcCn`,
	"orange-4": `otGDJYF91m`,
	"orange-5": `toUiHmq7d9`,
	"orange-6": `AJMf59lxm7`,
	"green-1": `Ydcgqnfe2R`,
	"green-2": `I2UlnPBBW2`,
	"green-3": `QIbcc2nbqy`,
	"green-4": `vscT7Q2u8Z`,
	"green-5": `dpnnthCuIw`,
	"green-6": `fwS3gtYhKO`,
	"blue-1": `clODwYArC8`,
	"blue-2": `kHLwI410S6`,
	"blue-3": `fJq4a8AqU1`,
	"blue-4": `Sa0OGdMTdo`,
	"blue-5": `nHyqbGCBUt`,
	"blue-6": `gRKqnSXsQF`,
	"yellow-1": `wyqTeK8lPS`,
	"yellow-2": `JeiSKWVSP7`,
	"yellow-3": `giTMbJJHR5`,
	"yellow-4": `VwYbtvOrxL`,
	"yellow-5": `UNi9wcwjlI`,
	"yellow-6": `YhTSRK29yH`,
	"purple-1": `GRs1gtIfSD`,
	"purple-2": `QLDX8bwiGE`,
	"purple-3": `LAmyUFDR73`,
	"purple-4": `MAjXCH77Sx`,
	"purple-5": `wMqIn2AIoz`,
	"purple-6": `Ed9JzYZuUh`,
	"black-1": `MWw_wT5ILH`,
	"black-2": `bP0BWW9J46`,
	"black-3": `kdwoKnF68c`,
	"black-4": `RujWf9GyZs`,
	"black-5": `fZ1_KBBR3q`,
	"black-6": `G6XQtzRy4l`,
	"picker-theme": `N1riCr_vo2`,
	"arrow-regular": `gX1cZ64IMN`,
	"modal-root": `k20FCthscX`,
	"modal-header__root": `T39xG6gev6`,
	"modal-header__ctn": `aIc97jJ7zA`,
	"modal-header__title": `e7QZc6WuSA`,
	"modal-header__icon": `PQM8AvKK5w`,
	"modal-footer__root": `lsnuHkEbaK`,
	"modal-footer__cancel": `qblwVBZX9h`,
	"modal-footer__confirm--disabled": `UPgS7D1Rbm`,
	"link-reviews__ctn": `O8HkpW5rNm`,
	"link-reviews__filter": `Sb8t5VELh8`,
	"link-review-select__select-container": `hjQtq9XPz3`,
	"filter-input__root": `SYrrQEYWCE`,
	"filter-input__input": `sBpJOsQWHy`,
	"filter-input__icon": `s_BB3Paszk`
};
export default ___CSS_LOADER_EXPORT___;
